import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { AppState, selectbuyerState, buyerState } from 'src/store/reducers';
import { constants } from 'src/appconstant';
import { NavigationService } from '../../core/services/navigation/navigation.service';
import { BuyerService } from './buyer.service';

@Component({
  selector: 'app-buyer',
  templateUrl: './buyer.component.html',
  styleUrls: ['./buyer.component.scss']
})
export class BuyerComponent implements OnInit {
  buyer;
  getState: Observable<any>;
  constructor(
    private store: Store<buyerState>,
    private buyerService: BuyerService,
    private navigation: NavigationService
  ) {
    this.getState = this.store.select(selectbuyerState);

  }
  // https://s3-eu-west-1.amazonaws.com/kr-web/announcements/3/NXq3rW0rBYsGc694Q08bzblD.jpg

  ngOnInit() {
 /*    this.buyer = [
      {"image_url":"announcements/3/6qEJm0xWPcH7GEyYtyAHc1kC.png","cities":['Helsinki'],"id":90,"title":"cartoon","image":"6qEJm0xWPcH7GEyYtyAHc1kC.png","details":"new test announcement","category_id":5,"price":9,"price_unit":"hectare","user_id":3,"status":"active","expiry_date":"2019-01-30T12:30:00.000Z","weight":2,"type":"buy","weight_unit":"kilogram","more_information":null,"created_at":"2019-01-17T06:31:16.000Z","updated_at":"2019-01-18T11:25:27.000Z","addresses":[]},
      {"image_url":"announcements/3/p5MkeLMOcpqD1BcPKONy50YB.jpg","cities":['Helsinki'],"id":91,"title":"ball","image":"p5MkeLMOcpqD1BcPKONy50YB.jpg","details":"new test announcement","category_id":5,"price":9,"price_unit":"hectare","user_id":3,"status":"active","expiry_date":"2019-01-30T12:30:00.000Z","weight":2,"type":"buy","weight_unit":"kilogram","more_information":null,"created_at":"2019-01-17T06:36:23.000Z","updated_at":"2019-01-18T11:23:56.000Z","addresses":[]},
      {"image_url":"announcements/3/NXq3rW0rBYsGc694Q08bzblD.jpg","cities":['Helsinki'],"id":92,"title":"fish wakka","image":"NXq3rW0rBYsGc694Q08bzblD.jpg","details":"new test announcement","category_id":5,"price":9,"price_unit":"hectare","user_id":3,"status":"active","expiry_date":"2019-01-30T12:30:00.000Z","weight":2,"type":"buy","weight_unit":"kilogram","more_information":null,"created_at":"2019-01-17T06:44:42.000Z","updated_at":"2019-01-18T11:23:38.000Z","addresses":[]},
      {"image_url":"announcements/3/nH2dSTKk7JZ1WEpU8grNuk8K.jpg","cities":['Helsinki'],"id":17,"title":"fish wakka","image":"nH2dSTKk7JZ1WEpU8grNuk8K.jpg","details":"new test announcement","category_id":5,"price":9,"price_unit":"hectare","user_id":3,"status":"active","expiry_date":"2019-01-30T12:30:00.000Z","weight":2,"type":"buy","weight_unit":"kilogram","more_information":null,"created_at":"2019-01-15T13:53:53.000Z","updated_at":"2019-01-18T11:13:34.000Z","addresses":[]},
      {"image_url":"announcements/3/Vmb86M4jHiQcS-26Swmy4zXL.jpg","cities":['Helsinki'],"id":15,"title":"ball","image":"Vmb86M4jHiQcS-26Swmy4zXL.jpg","details":"new test announcement","category_id":5,"price":9,"price_unit":"hectare","user_id":3,"status":"active","expiry_date":"2019-01-30T12:30:00.000Z","weight":2,"type":"buy","weight_unit":"kilogram","more_information":null,"created_at":"2019-01-15T12:30:15.000Z","updated_at":"2019-01-18T10:51:29.000Z","addresses":[]}]; */
     this.getState.subscribe((state) => {
      if (state.buyer) {
         this.buyer = state.buyer.rows;
       }
     });
     this.buyerService.dispatchBuyerAction();
  }

  retrieveImage(image) {
    return (image === '' || image === undefined) && 
    "../../../assets/images/noImageFound.jpg" || constants.AWS_URL + image;
  }
  getComma(length, index) {
    return (length === index) && '' || ',';
  }

  viewall(route, buyrSellr)
  {
    this.navigation.navigateTo(route, '', buyrSellr);
  }
  routeTo(path,id){
    if(localStorage.getItem("token")){
    this.navigation.navigateTo([`${path}/${id}`]);
    }
    else{
      this.navigation.navigateTo('login');
    }
  }
}
